(function () {
  var PRODUCT_CACHE_KEY = 'ownart:products:v1';
  var PRODUCT_CACHE_TTL = 120000;
  var PRODUCT_REFRESH_INTERVAL = 120000;
  var HOVER_PRELOAD_BATCH_SIZE = 6;
  var hoverPreloadQueue = [];
  var hoverPreloadScheduled = false;

  function sectionBrandFromPath() {
    var params = new URLSearchParams(window.location.search);
    var brandParam = params.get('brand');
    if (['all', 'aurem', 'viverra', 'evara'].indexOf(brandParam) !== -1) return brandParam;

    var path = window.location.pathname.toLowerCase();
    if (path.indexOf('aurem-products') !== -1) return 'aurem';
    if (path.indexOf('viverra-products') !== -1) return 'viverra';
    if (path.indexOf('evara-products') !== -1) return 'evara';
    return '';
  }

  function selectedValues(inputs) {
    return inputs.filter(function (input) {
      return input.checked;
    }).map(function (input) {
      return input.value;
    }).filter(function (value) {
      return value !== 'all';
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function normalizeBrand(product) {
    var tags = Array.isArray(product.tags) ? product.tags.join('|').toLowerCase() : '';
    var vendor = String(product.vendor || '').toLowerCase();
    var title = String(product.title || '').toLowerCase();

    if (tags.indexOf('viverra') !== -1 || vendor.indexOf('viverra') !== -1 || title.indexOf('viverra') !== -1) return 'viverra';
    if (tags.indexOf('evara') !== -1 || vendor.indexOf('evara') !== -1 || title.indexOf('evara') !== -1) return 'evara';
    if (tags.indexOf('aur') !== -1 || vendor.indexOf('aur') !== -1 || title.indexOf('aur') !== -1) return 'aurem';
    return '';
  }

  function normalizeCategory(product) {
    return slugify(product.product_type);
  }

  function categoryLabel(product) {
    return String(product.product_type || '').trim();
  }

  function formatPrice(price) {
    var amount = Number(price || 0);
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function productImage(product) {
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;
    if (Array.isArray(product.images) && product.images.length > 0) {
      return product.images[0].src || product.images[0];
    }
    return '';
  }

  function productImages(product) {
    var images = [];

    if (Array.isArray(product.images)) {
      images = product.images.map(function (image) {
        return typeof image === 'string' ? image : image && image.src;
      }).filter(Boolean);
    }

    var featured = productImage(product);
    if (featured && images.indexOf(featured) === -1) {
      images.unshift(featured);
    }

    return images;
  }

  function productUrl(product) {
    return product.handle ? '/products/' + product.handle : '#';
  }

  function availableVariant(product) {
    return Array.isArray(product.variants) ? product.variants.find(function (item) {
      return item.available;
    }) : null;
  }

  function parseCardImages(card) {
    var images = [];

    try {
      images = JSON.parse(card.dataset.productImages || '[]');
    } catch (error) {
      images = [];
    }

    if (!Array.isArray(images)) images = [];
    images = images.filter(Boolean).map(function (source) {
      return new URL(source, window.location.href).toString();
    });

    if (card.dataset.productImage) {
      var featuredSource = new URL(card.dataset.productImage, window.location.href).toString();
      var featuredPath = featuredSource.replace(/([?&])width=\d+(&?)/, '$1').replace(/[?&]$/, '');
      var hasFeatured = images.some(function (source) {
        return source.replace(/([?&])width=\d+(&?)/, '$1').replace(/[?&]$/, '') === featuredPath;
      });
      if (!hasFeatured) images.unshift(featuredSource);
    }

    return images;
  }

  function setCardImage(card, index) {
    var image = card.querySelector('[data-catalog-image]');
    var images = parseCardImages(card);
    if (!image || images.length === 0) return;

    var nextIndex = ((index % images.length) + images.length) % images.length;
    var nextSource = images[nextIndex];
    if (!nextSource) return;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.dataset.catalogImageIndex = String(nextIndex);
    image.src = nextSource;
  }

  function markPreviewFailed(card) {
    card.dataset.catalogPreviewReady = 'false';
    card.dataset.catalogPreviewFailed = 'true';
    var media = card.querySelector('.ownart-commerce__media');
    if (media) {
      media.classList.remove('has-preview');
      media.setAttribute('data-preview-unavailable', 'true');
    }
  }

  function ensurePreviewImage(card) {
    var media = card.querySelector('.ownart-commerce__media');
    var image = card.querySelector('[data-catalog-image]');
    var preview = card.querySelector('[data-catalog-preview-image]');

    if (!media || !image) return null;
    if (preview) return preview;

    preview = image.cloneNode(false);
    preview.className = 'ownart-commerce__preview-image';
    preview.removeAttribute('srcset');
    preview.removeAttribute('sizes');
    preview.removeAttribute('loading');
    preview.removeAttribute('fetchpriority');
    preview.setAttribute('aria-hidden', 'true');
    preview.decoding = 'async';
    preview.dataset.catalogPreviewImage = 'true';
    media.insertBefore(preview, image.nextSibling);
    return preview;
  }

  function scheduleHoverPreloadQueue() {
    if (hoverPreloadScheduled) return;
    hoverPreloadScheduled = true;

    var scheduler = window.requestIdleCallback || function (callback) {
      return window.setTimeout(function () {
        callback({ timeRemaining: function () { return 0; } });
      }, 120);
    };

    scheduler(function () {
      hoverPreloadScheduled = false;

      var batch = hoverPreloadQueue.splice(0, HOVER_PRELOAD_BATCH_SIZE);
      batch.forEach(function (card) {
        preloadHoverImage(card);
      });

      if (hoverPreloadQueue.length > 0) {
        scheduleHoverPreloadQueue();
      }
    });
  }

  function enqueueHoverPreload(card) {
    if (!card || card.dataset.catalogPreviewQueued === 'true' || card.dataset.catalogPreviewReady === 'true') return;

    card.dataset.catalogPreviewQueued = 'true';
    hoverPreloadQueue.push(card);
    scheduleHoverPreloadQueue();
  }

  function preloadHoverImage(card) {
    var images = parseCardImages(card);
    var preview = ensurePreviewImage(card);
    var hoverSource = images[1];

    if (!preview || !hoverSource) {
      markPreviewFailed(card);
      return;
    }

    preview.onload = function () {
      card.dataset.catalogPreviewReady = 'true';
      card.dataset.catalogPreviewFailed = 'false';
      var media = card.querySelector('.ownart-commerce__media');
      if (media) media.removeAttribute('data-preview-unavailable');
    };

    preview.onerror = function () {
      markPreviewFailed(card);
    };

    preview.src = hoverSource;
    preview.dataset.catalogImageIndex = '1';

    if (preview.complete && preview.naturalWidth > 0) {
      card.dataset.catalogPreviewReady = 'true';
      card.dataset.catalogPreviewFailed = 'false';
    }
  }

  function isPointerInside(element, event) {
    if (!element || typeof event.clientX !== 'number' || typeof event.clientY !== 'number') return false;

    var rect = element.getBoundingClientRect();
    return event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
  }

  function transitionCardImage(card, index) {
    var media = card.querySelector('.ownart-commerce__media');
    var image = card.querySelector('[data-catalog-image]');
    var preview = ensurePreviewImage(card);
    var currentIndex = Number(image && image.dataset.catalogImageIndex || 0);
    var images = parseCardImages(card);
    var nextIndex = images.length ? ((index % images.length) + images.length) % images.length : 0;

    if (!media || !image || !preview || images.length === 0 || currentIndex === nextIndex) return;

    window.clearTimeout(Number(card.dataset.catalogImageTimer || 0));
    preview.src = images[nextIndex];
    media.classList.add('is-crossfading');

    var timer = window.setTimeout(function () {
      setCardImage(card, nextIndex);
      media.classList.remove('is-crossfading');
      if (!media.classList.contains('is-hovering')) {
        media.classList.remove('has-preview');
      }
    }, 420);

    card.dataset.catalogImageTimer = String(timer);
  }

  function previewCardImage(card, index) {
    var media = card.querySelector('.ownart-commerce__media');
    var preview = ensurePreviewImage(card);
    var images = parseCardImages(card);
    var nextIndex = images.length ? ((index % images.length) + images.length) % images.length : 0;

    if (!media || !preview || images.length === 0) return;
    if (index === 1 && card.dataset.catalogPreviewReady !== 'true') {
      enqueueHoverPreload(card);
      return;
    }

    if (preview.src !== images[nextIndex]) {
      preview.src = images[nextIndex];
    }
    preview.dataset.catalogImageIndex = String(nextIndex);
    media.classList.add('has-preview');
  }

  function clearPreviewImage(card) {
    var media = card.querySelector('.ownart-commerce__media');
    if (!media) return;
    media.classList.remove('has-preview');
  }

  function bindProductImages(card) {
    if (!card || card.dataset.catalogImagesReady === 'true') return;
    card.dataset.catalogImagesReady = 'true';

    var image = card.querySelector('[data-catalog-image]');
    var next = card.querySelector('[data-catalog-next]');
    var media = card.querySelector('.ownart-commerce__media');
    var images = parseCardImages(card);

    if (!image || !media || images.length === 0) {
      if (next) next.hidden = true;
      return;
    }

    image.dataset.catalogImageIndex = '0';

    image.addEventListener('error', function () {
      var activeIndex = Number(image.dataset.catalogImageIndex || 0);
      if (images.length <= 1) return;
      setCardImage(card, activeIndex + 1);
    });

    if (images.length > 1) {
      enqueueHoverPreload(card);

      media.addEventListener('mouseenter', function (event) {
        if (!isPointerInside(media, event)) return;
        media.classList.add('is-hovering');
        previewCardImage(card, 1);
      });

      media.addEventListener('mousemove', function (event) {
        if (isPointerInside(media, event)) return;
        media.classList.remove('is-hovering');
        clearPreviewImage(card);
      });

      media.addEventListener('mouseleave', function () {
        media.classList.remove('is-hovering');
        clearPreviewImage(card);
      });
    } else if (next) {
      next.hidden = true;
    }
  }

  function bindAllProductImages(section) {
    Array.prototype.slice.call(section.querySelectorAll('[data-catalog-card]')).forEach(bindProductImages);
  }

  function availableAuremProducts(products) {
    return products.filter(function (product) {
      return normalizeBrand(product) === 'aurem' && availableVariant(product);
    });
  }

  function getCachedProducts() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(PRODUCT_CACHE_KEY) || 'null');
      if (!cached || !Array.isArray(cached.products)) return null;
      if (Date.now() - Number(cached.timestamp || 0) > PRODUCT_CACHE_TTL) return null;
      return cached.products;
    } catch (error) {
      return null;
    }
  }

  function setCachedProducts(products) {
    try {
      sessionStorage.setItem(PRODUCT_CACHE_KEY, JSON.stringify({
        timestamp: Date.now(),
        products: products
      }));
    } catch (error) {}
  }

  function fetchProducts(forceRefresh) {
    var cached = forceRefresh ? null : getCachedProducts();
    if (cached) return Promise.resolve(cached);

    return fetch(window.location.origin + '/collections/all/products.json?limit=50', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product data unavailable');
        return response.json();
      })
      .then(function (payload) {
        var products = Array.isArray(payload.products) ? payload.products : [];
        setCachedProducts(products);
        window.dispatchEvent(new CustomEvent('ownart:products-updated', { detail: { products: products } }));
        return products;
      });
  }

  function categoriesFromProducts(products) {
    var seen = {};

    return availableAuremProducts(products).reduce(function (categories, product) {
      var label = categoryLabel(product);
      var slug = normalizeCategory(product);
      if (!label || !slug || seen[slug]) return categories;
      seen[slug] = true;
      categories.push({ label: label, slug: slug });
      return categories;
    }, []).sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });
  }

  function buildProductCard(product, index) {
    var variant = availableVariant(product);
    if (!variant) return '';

    var brand = normalizeBrand(product);
    if (brand !== 'aurem') return '';

    var image = productImage(product);
    var images = productImages(product);
    var category = normalizeCategory(product);
    var price = Number(variant.price || 0);
    var title = escapeHtml(product.title);
    var vendor = escapeHtml(product.vendor || 'AURÈM');
    var type = escapeHtml(product.product_type || '');
    var url = productUrl(product);
    var created = Date.parse(product.created_at || product.published_at || '') || 0;
    var imageMarkup = image ? '<img src="' + escapeHtml(image) + '" alt="' + title + '" loading="' + (index < 4 ? 'eager' : 'lazy') + '" fetchpriority="' + (index < 4 ? 'high' : 'auto') + '" data-ownart-lightbox="false" data-catalog-image="true">' : '';

    return [
      '<article class="ownart-commerce__card" data-catalog-card data-ownart-wishlist-card data-product-handle="' + escapeHtml(product.handle || '') + '" data-product-title="' + title + '" data-product-url="' + escapeHtml(url) + '" data-product-image="' + escapeHtml(image) + '" data-product-images="' + escapeHtml(JSON.stringify(images)) + '" data-product-vendor="' + vendor + '" data-product-type="' + type + '" data-product-price="' + escapeHtml(formatPrice(variant.price)) + '" data-brand="' + brand + '" data-category="' + escapeHtml(category) + '" data-available="true" data-price="' + price + '" data-created="' + created + '" data-index="' + (index + 1) + '">',
      '<a class="ownart-commerce__card-inner" href="' + escapeHtml(url) + '">',
      '<span class="ownart-commerce__media">',
      imageMarkup,
      '<button class="ownart-commerce__favorite" type="button" aria-label="Add to wishlist" data-catalog-favorite>&hearts;</button>',
      '<button class="ownart-commerce__next" type="button" aria-label="Next image" data-catalog-next' + (images.length > 1 ? '' : ' hidden') + '>&rsaquo;</button>',
      '</span>',
      '<span class="ownart-commerce__body">',
      '<h3>' + title + '</h3>',
      type ? '<span class="ownart-commerce__materials">' + type + '</span>' : '',
      '<span class="ownart-commerce__price">' + escapeHtml(formatPrice(variant.price)) + '</span>',
      '<span class="ownart-commerce__stock" data-stock="available">Available online</span>',
      '</span>',
      '</a>',
      '</article>'
    ].join('');
  }

  function sectionCategoryFromHash() {
    var params = new URLSearchParams(window.location.search);
    var categoryParam = params.get('category');
    if (categoryParam) return slugify(categoryParam);

    var hash = window.location.hash ? window.location.hash.replace('#', '').split('?')[0] : '';
    return slugify(hash);
  }

  function sortValueFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var sortParam = params.get('sort_by') || '';
    var map = {
      'manual': 'recommended',
      'best-selling': 'best-selling',
      'created-descending': 'created-descending',
      'price-ascending': 'price-asc',
      'price-descending': 'price-desc'
    };

    return map[sortParam] || '';
  }

  function sortValueToUrl(value) {
    var map = {
      'best-selling': 'best-selling',
      'created-descending': 'created-descending',
      'price-asc': 'price-ascending',
      'price-desc': 'price-descending'
    };

    return map[value] || '';
  }

  function updateSortUrl(value) {
    if (!window.history || !window.history.replaceState) return;

    var url = new URL(window.location.href);
    var nextSort = sortValueToUrl(value);
    if (nextSort) {
      url.searchParams.set('sort_by', nextSort);
    } else {
      url.searchParams.delete('sort_by');
    }
    window.history.replaceState({}, '', url.toString());
  }

  function initCatalog(section) {
    if (!section || section.dataset.catalogReady === 'true') return;
    section.dataset.catalogReady = 'true';

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-catalog-card]'));
    var grid = section.querySelector('[data-catalog-grid]');
    var count = section.querySelector('[data-catalog-count]');
    var empty = section.querySelector('[data-catalog-empty]');
    var brandInputs = Array.prototype.slice.call(section.querySelectorAll('[data-catalog-brand]'));
    var categoryOptions = section.querySelector('[data-catalog-category-options]');
    var categoryStatus = section.querySelector('[data-catalog-category-status]');
    var categoryInputs = Array.prototype.slice.call(section.querySelectorAll('[data-catalog-category]'));
    var sortInputs = Array.prototype.slice.call(section.querySelectorAll('[data-catalog-sort]'));
    var viewButtons = Array.prototype.slice.call(section.querySelectorAll('[data-catalog-view]'));
    var availableInput = section.querySelector('[data-catalog-available]');
    var initialBrand = sectionBrandFromPath() || section.dataset.initialBrand || 'all';

    var initialBrandInput = brandInputs.find(function (input) {
      return input.value === initialBrand;
    }) || brandInputs.find(function (input) {
      return input.value === 'all';
    });
    if (initialBrandInput) initialBrandInput.checked = true;

    var initialSort = sortValueFromUrl();
    if (initialSort) {
      var initialSortInput = sortInputs.find(function (input) {
        return input.value === initialSort;
      });
      if (initialSortInput) initialSortInput.checked = true;
    }

    function setCategoryStatus(message) {
      if (!categoryStatus) return;
      categoryStatus.hidden = !message;
      categoryStatus.textContent = message || '';
    }

    function selectedSort() {
      var active = sortInputs.find(function (input) {
        return input.checked;
      });
      return active ? active.value : 'recommended';
    }

    function applyCategoryFromHash() {
      var activeCategory = sectionCategoryFromHash();

      categoryInputs.forEach(function (input) {
        if (input.hasAttribute('data-catalog-category-all')) {
          input.checked = activeCategory === '';
          return;
        }
        input.checked = activeCategory !== '' && input.value === activeCategory;
      });
    }

    function syncAllCategoryInput(changedInput) {
      var allInput = categoryInputs.find(function (input) {
        return input.hasAttribute('data-catalog-category-all');
      });
      if (!allInput) return;

      if (changedInput && changedInput.hasAttribute('data-catalog-category-all') && changedInput.checked) {
        categoryInputs.forEach(function (input) {
          if (input !== allInput) input.checked = false;
        });
        return;
      }

      var hasSpecificCategory = categoryInputs.some(function (input) {
        return input !== allInput && input.checked;
      });
      allInput.checked = !hasSpecificCategory;
    }

    function applyCatalogState() {
      var activeBrandInput = brandInputs.find(function (input) {
        return input.checked;
      });
      var activeBrand = activeBrandInput ? activeBrandInput.value : 'all';
      var activeCategories = selectedValues(categoryInputs);
      var requireAvailable = availableInput ? availableInput.checked : false;
      var visibleCards = [];

      cards.forEach(function (card) {
        var brandMatch = activeBrand === 'all' || card.dataset.brand === activeBrand;
        var categoryMatch = activeCategories.length === 0 || activeCategories.indexOf(card.dataset.category) !== -1;
        var availableMatch = !requireAvailable || card.dataset.available === 'true';
        var isVisible = brandMatch && categoryMatch && availableMatch;
        card.hidden = !isVisible;
        if (isVisible) visibleCards.push(card);
      });

      visibleCards.sort(function (a, b) {
        var sort = selectedSort();
        if (sort === 'price-asc') {
          return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
        }
        if (sort === 'price-desc') {
          return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
        }
        if (sort === 'created-descending') {
          var newest = Number(b.dataset.created || 0) - Number(a.dataset.created || 0);
          if (newest !== 0) return newest;
          return Number(b.dataset.index || 0) - Number(a.dataset.index || 0);
        }
        return Number(a.dataset.index || 0) - Number(b.dataset.index || 0);
      });

      visibleCards.forEach(function (card) {
        grid.appendChild(card);
      });

      if (count) count.textContent = String(visibleCards.length);
      if (empty) empty.classList.toggle('is-visible', visibleCards.length === 0);
    }

    function bindCategoryInputs() {
      categoryInputs = Array.prototype.slice.call(section.querySelectorAll('[data-catalog-category]'));
      categoryInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          syncAllCategoryInput(input);
          applyCatalogState();
        });
      });
      applyCategoryFromHash();
      syncAllCategoryInput();
    }

    function renderCategoryOptions(categories) {
      if (!categoryOptions) return;

      if (!categories.length) {
        categoryOptions.innerHTML = '';
        setCategoryStatus('No product categories are currently available.');
        return;
      }

      var allCategoryLabel = categoryOptions.dataset.catalogAllCategoryLabel || section.dataset.allCategoryLabel || 'All Jewelry';
      var categoryMarkup = [
        '<label class="ownart-commerce__control">',
        '<input type="checkbox" value="all" data-catalog-category data-catalog-category-all checked>',
        '<span class="ownart-commerce__check" aria-hidden="true"></span>',
        '<span>' + escapeHtml(allCategoryLabel) + '</span>',
        '</label>'
      ].join('');

      categoryOptions.innerHTML = categoryMarkup + categories.map(function (category) {
        return [
          '<label class="ownart-commerce__control">',
          '<input type="checkbox" value="' + escapeHtml(category.slug) + '" data-catalog-category>',
          '<span class="ownart-commerce__check" aria-hidden="true"></span>',
          '<span>' + escapeHtml(category.label) + '</span>',
          '</label>'
        ].join('');
      }).join('');

      setCategoryStatus('');
      bindCategoryInputs();
    }

    function syncCategories(products) {
      renderCategoryOptions(categoriesFromProducts(products));
      applyCatalogState();
    }

    function hydrateFromShopifyProducts() {
      if (!grid || cards.length > 0) {
        applyCatalogState();
        return;
      }

      fetchProducts(false)
        .then(function (products) {
          syncCategories(products);
          var markup = products.map(buildProductCard).join('');
      if (markup) {
        grid.insertAdjacentHTML('beforeend', markup);
        cards = Array.prototype.slice.call(section.querySelectorAll('[data-catalog-card]'));
        bindAllProductImages(section);
      }
      applyCatalogState();
        })
        .catch(function () {
          setCategoryStatus('Product categories could not be loaded. Please try again later.');
          applyCatalogState();
        });
    }

    function setCatalogView(view) {
      var activeView = view === 'feed' ? 'feed' : 'grid';
      section.classList.toggle('is-feed-view', activeView === 'feed');

      viewButtons.forEach(function (button) {
        var isActive = button.dataset.catalogView === activeView;
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    brandInputs.forEach(function (input) {
      input.addEventListener('change', applyCatalogState);
    });
    sortInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        updateSortUrl(selectedSort());
        applyCatalogState();
      });
    });
    bindCategoryInputs();
    if (availableInput) availableInput.addEventListener('change', applyCatalogState);

    viewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setCatalogView(button.dataset.catalogView);
      });
    });

    window.addEventListener('hashchange', function () {
      applyCategoryFromHash();
      applyCatalogState();
    });

    section.addEventListener('click', function (event) {
      var favorite = event.target.closest('[data-catalog-favorite]');
      if (favorite && section.contains(favorite)) {
        event.preventDefault();
        favorite.classList.toggle('is-active');
        favorite.setAttribute('aria-pressed', favorite.classList.contains('is-active') ? 'true' : 'false');
        return;
      }

      var next = event.target.closest('[data-catalog-next]');
      if (!next || !section.contains(next)) return;

      event.preventDefault();
      event.stopPropagation();

      var card = next.closest('[data-catalog-card]');
      if (!card) return;

      var image = card.querySelector('[data-catalog-image]');
      var images = parseCardImages(card);
      if (!image || images.length <= 1) return;

      var activeIndex = Number(image.dataset.catalogImageIndex || 0);
      var media = card.querySelector('.ownart-commerce__media');
      if (media) media.classList.add('is-cycling');
      transitionCardImage(card, activeIndex + 1);
      window.setTimeout(function () {
        if (media) media.classList.remove('is-cycling');
      }, 460);
    });

    bindAllProductImages(section);
    setCatalogView('grid');
    fetchProducts(false).then(syncCategories).catch(function () {
      setCategoryStatus('Product categories could not be loaded. Please try again later.');
    });
    setInterval(function () {
      fetchProducts(true).then(syncCategories).catch(function () {});
    }, PRODUCT_REFRESH_INTERVAL);
    hydrateFromShopifyProducts();
  }

  function initAllCatalogs() {
    document.querySelectorAll('[data-ownart-commerce-catalog]').forEach(initCatalog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCatalogs);
  } else {
    initAllCatalogs();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCatalog(event.target.querySelector('[data-ownart-commerce-catalog]'));
  });
})();
